import { Box, Grid, Theme, Typography } from "@mui/material";
import { KeyValue } from "../../ApplicationDetails/personalDetails";
import { ViewProfileProps } from "../types";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../redux-store/reducers";
import { getUniqueIdentityText, isOnboardingTypeMinor } from "../../../utils/utilityFunctions";


export default function ViewProfileOverview({ overviewData }: { overviewData: any }): JSX.Element {
    const { name, pan, email, mobile, onboardingType, applicants, countryCode } = overviewData;
    const primaryApplicant = applicants.find((applicant: any) => applicant.applicant_type === '1');
    const { company = "WMS" } = useSelector((state: RootStateType) => state.navbarInfo)

    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    bgcolor: 'white',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px',
                    border: `1px solid ${theme.palette.grey[100]}`,
                    padding: '25px',
                    mb: '40px'

                })}
            >
                <Box>
                    <Grid container >
                        <Grid item xs={12} >
                            <Typography variant='body_600' sx={(theme: Theme) => ({ fontWeight: 700, color: theme.palette.primary[900], mb: '25px' })}>
                                Overview
                            </Typography>

                        </Grid>
                        <Grid
                            item
                            container
                            rowSpacing={3}
                            columnSpacing={5.5}
                            direction="row"

                        >
                            <KeyValue title={'Name'} description={isOnboardingTypeMinor(onboardingType) ? primaryApplicant?.minorName : name} />
                            <KeyValue
                                title={`${getUniqueIdentityText(company)?.pan}`}
                                description={pan}
                            />
                            <KeyValue
                                title={'Mobile Number'}
                                description={mobile ? `${countryCode ?? '-'} ${mobile}` : '-'}
                            />
                            <KeyValue title={'Email ID'} description={email} />

                        </Grid>

                    </Grid>
                </Box>
            </Box >
        </>
    )
}